import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import TaskAltIcon from '@mui/icons-material/TaskAlt'
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt'
import UpdateIcon from '@mui/icons-material/Update'
import WebhookIcon from '@mui/icons-material/Webhook'
import { Grid, Typography } from '@mui/material'
import { useState } from 'react'
import { EntityAvatar } from 'theme/components'
import PandaIcon from '../../images/pandadoc.png'
import { renderTimelineText } from '../DataGrid/renderTimelineText'

const renderTimelineIcons = action => {
  switch (action) {
    case 'Approval':
    case 'approval':
      return <ThumbUpOffAltIcon />
    case 'Deals':
    case 'deals':
    case 'Save':
      return <AttachMoneyIcon />
    case 'document':
    case 'Generation':
    case 'Generate':
      return <EntityAvatar photoUrl={PandaIcon} />
    case 'Update':
    case 'update':
      return <UpdateIcon />
    case 'productUpdate':
      return <ShoppingCartIcon />
    case 'task':
    case 'startDate':
      return <TaskAltIcon sx={{ color: 'rgb(247, 63, 236)' }} />
    case 'Webhook':
    case 'webhook':
      return <WebhookIcon />
  }
}

const TimelineType = ({ type }) => {
  const [isHovered, setIsHovered] = useState(false)
  return (
    <Grid
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      item
      xs={2}
      sx={{ display: 'flex', alignItems: 'center', height: '100%' }}
    >
      {isHovered ? (
        <Typography>{renderTimelineText(type)}</Typography>
      ) : (
        <Typography>{renderTimelineIcons(type)}</Typography>
      )}
    </Grid>
  )
}

export default TimelineType
